
$(function () {
  if($(".psl-guest-confirm-delivery-container").length === 0) return;

  let xProgram = 'school-lunch';
  setCookie('X-PROGRAM', xProgram,365 );
  let uuid = $('#uuid').text();
  request({
    url:'/school-lunch/deliveries/uuid/'+uuid,
    callback:function(order){
      $('[data-prop="school"]').text(order.schoolName);
      $('[data-prop="address"]').text(order.address1);
      $('[data-prop="address"]').html(order.address1+ ', ' +order.city+ ', ' +order.state+ ', ' +order.zip);

      $('.head .text').text(new Date(order.date).format(' F j, Y') + ' at ' + order.time);
      $.each(order.meals,function (k,item) {
        $('.meals').append(
          $('<div>').attr({class:'meal'})
            .append($('<div>').attr({class:'count'}).text(item.quantity))
            .append($('<div>').attr({class:'names'}).text(item.mealName+' '+item.mealSizeName+' with '+item.mealOptionName))
        );
      });
    }
  });

  Date.prototype.format = function (format, utc) {
    if (isNaN(this.valueOf())) {
      return 'Invalid Date';
    }

    let fullMonthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];

    let shortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    let fullDayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday",
      "Friday", "Saturday"];

    let shortDayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    let fullYear = utc ? this.getUTCFullYear() : this.getFullYear();
    let humanYear = fullYear - 2000;

    let month = utc ? this.getUTCMonth() : this.getMonth();
    let monthHumanRaw = month + 1;
    let monthHuman = monthHumanRaw > 9 ? monthHumanRaw : '0' + monthHumanRaw;

    let date = utc ? this.getUTCDate() : this.getDate();
    let humanDate = date > 9 ? date : '0' + date;

    let hour = utc ? this.getUTCHours() : this.getHours();
    let human24Hour = hour > 9 ? hour : '0' + hour;

    let human12Hour = hour % 12;
    if (hour === 12) {
      human12Hour = 12;
    }
    human12Hour = human12Hour > 9 ? human12Hour : '0' + human12Hour;

    let ampm = hour > 11 ? 'pm' : 'am';

    let minute = utc ? this.getUTCMinutes() : this.getMinutes();
    let humanMinute = minute > 9 ? minute : '0' + minute;

    let second = utc ? this.getUTCSeconds() : this.getSeconds();
    let humanSecond = second > 9 ? second : '0' + second;

    let day = utc ? this.getUTCDay() : this.getDay();

    let result = format
      .replace(/d/, '__d__')
      .replace(/j/, '__j__')
      .replace(/m/, '__m__')
      .replace(/n/, '__n__')
      .replace(/Y/, '__Y__')
      .replace(/y/, '__y__')
      .replace(/H/, '__H__')
      .replace(/h/, '__h__')
      .replace(/a/, '__a__')
      .replace(/A/, '__A__')
      .replace(/i/, '__i__')
      .replace(/s/, '__s__')
      .replace(/F/, '__F__')
      .replace(/M/, '__M__')
      .replace(/l/, '__l__')
      .replace(/D/, '__D__');

    return result
      .replace(/__d__/, humanDate)
      .replace(/__j__/, date)
      .replace(/__m__/, monthHuman)
      .replace(/__n__/, monthHumanRaw)
      .replace(/__Y__/, fullYear)
      .replace(/__y__/, humanYear)
      .replace(/__H__/, human24Hour)
      .replace(/__h__/, human12Hour)
      .replace(/__a__/, ampm)
      .replace(/__A__/, ampm.toUpperCase())
      .replace(/__i__/, humanMinute)
      .replace(/__s__/, humanSecond)
      .replace(/__F__/, fullMonthNames[month])
      .replace(/__M__/, shortMonthNames[month])
      .replace(/__l__/, fullDayNames[day])
      .replace(/__D__/, shortDayNames[day]);
  };
});
